import { render } from "./announceArchive.vue?vue&type=template&id=17f9d9ac"
import script from "./announceArchive.vue?vue&type=script&lang=js"
export * from "./announceArchive.vue?vue&type=script&lang=js"

import "./announceArchive.vue?vue&type=style&index=0&id=17f9d9ac&lang=scss"

import exportComponent from "../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__